import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { faqData } from '../../data/mock';

const FAQSection = () => {
  return (
    <section className="py-16 sm:py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 uppercase tracking-wider">
            Questions?
          </h2>
          <p className="text-white/50 text-sm sm:text-base">
            Here are the most common ones
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-2xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqData.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="section-card px-4 sm:px-5 border-white/10 data-[state=open]:border-white/30 transition-colors"
              >
                <AccordionTrigger className="text-white hover:no-underline py-4 text-sm sm:text-base font-bold text-left gap-3 uppercase tracking-wider">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/50 pb-4 text-sm leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
